import React from "react";

const PanelTitleRow = ({ title, className = "", titleClassName = "" }) => {
  if (!title) {
    return null;
  }

  return (
    <div className={`ui-panel-title-row ${className}`.trim()}>
      <h2 className={`ui-panel-title-row__title ${titleClassName}`.trim()}>{title}</h2>
    </div>
  );
};

export default PanelTitleRow;
